export default {
  path: '/profil_user',
  name: 'profil_users',
  component: () => import('../components/profiluser/Layout'),
  redirect: { name: 'ProfilUserList' },
  meta: {
    breadcrumb: 'administration.profil.profils',
  },
  children: [
    {
      name: 'ProfilUserList',
      path: '',
      component: () => import('../views/profiluser/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProfilUserCreate',
      path: 'new',
      component: () => import('../views/profiluser/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ProfilUserShow',
      path: ':id',
      component: () => import('../views/profiluser/Show'),
      meta: {
        breadcrumb: 'administration.profil.profil',
      },
    },
    {
      name: 'ProfilUserUpdate',
      path: ':id/edit',
      component: () => import('../views/profiluser/Update'),
      meta: {
        breadcrumb: 'global.update',
      },
    },

  ]
};
